export default __webpack_public_path__ + "static/media/vipso-screenshot-1.1ed791f6.png";